/**
 * 性能采集：路由切换耗时
 *
 * FCP、LCP、CLS、INP 等浏览器性能指标受设备、网络和页面停留状态影响较大，
 * 容易产生无法直接定位业务问题的告警，已停止上报。
 */
import { nextTick } from 'vue';
import type { Router } from 'vue-router';
import { MONITOR_CONFIG } from '@/monitor/config';
import { track } from '@/monitor/core/aggregator';

export const setupPerformanceCollector = (router: Router): void => {
  /** 路由切换耗时：beforeEach 打点，afterEach + nextTick 结算 */
  let routeStart = 0;
  let routeFrom = '';
  router.beforeEach((_to, from) => {
    routeStart = performance.now();
    routeFrom = from.fullPath;
  });
  router.afterEach((to) => {
    const start = routeStart;
    const from = routeFrom;
    nextTick(() => {
      const duration = performance.now() - start;
      if (duration <= MONITOR_CONFIG.THRESHOLD.ROUTE_CHANGE) return;
      track({
        type: 'performance',
        level: 'warn',
        title: '路由切换缓慢',
        message: `切换到 ${to.path} 耗时超阈值`,
        source: to.path,
        extra: {
          来源: from || '(直接进入)',
          实测: `${Math.round(duration)}ms`,
          阈值: `${MONITOR_CONFIG.THRESHOLD.ROUTE_CHANGE}ms`,
        },
        timestamp: Date.now(),
      });
    });
  });
};
